/* import __COLOCATED_TEMPLATE__ from './add-tag-to-conversation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();